"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var constants_1 = __importStar(require("./constants"));
var sc = __importStar(require("./Icon.styles"));
function Icon(_a) {
    var _b;
    var children = _a.children, moreProps = __rest(_a, ["children"]);
    var colorProps = constants_1.iconColors[(_b = children === null || children === void 0 ? void 0 : children.type) === null || _b === void 0 ? void 0 : _b.name];
    return children ? react_1.default.createElement(sc.AvatarComponent, __assign({}, colorProps, moreProps), children) : null;
}
Icon.Kinds = {
    ACADEMY: constants_1.default.academy,
    ASSET_INVENTORY: constants_1.default.asset_inventory,
    ASSETS_AND_ATTRIBUTES: constants_1.default.assets_and_attributes,
    ASSURANCE_PLANS: constants_1.default.assurance_plans,
    BULK_IMPORTER: constants_1.default.bulk_importer,
    COMPLIANCE_MAPS: constants_1.default.compliance_maps,
    COMMUNITY: constants_1.default.community,
    FRAMEWORKS: constants_1.default.frameworks,
    ISSUE_TRACKER: constants_1.default.issue_tracker,
    LAUNCHPAD: constants_1.default.launchpad,
    MISSION_CONTROL: constants_1.default.mission_control,
    PROJECTS: constants_1.default.projects,
    REPORTS: constants_1.default.reports,
    RESULTS: constants_1.default.results,
    ROBOTS: constants_1.default.robots,
    SCHEDULER: constants_1.default.scheduler,
    STORYBOARD: constants_1.default.storyboard,
    STRATEGY: constants_1.default.strategy,
    TASK_TRACKER: constants_1.default.task_tracker,
    TIME_SHEETS: constants_1.default.time_sheets,
    TOOLKITS: constants_1.default.toolkits,
};
Icon.displayName = 'PageHeader.Icon';
exports.default = Icon;
//# sourceMappingURL=Icon.js.map